import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import { ThemedApp } from '@core/Theme/ThemedApp';
import { store } from '@core/store/Store';
import { installPreloadErrorReload } from '@core/utils/lazyWithRetry';
import '@core/i18n';
import './index.css';

// Before render: a stale `index.html` 404s its module preloads, and that fires before any
// component exists to catch it.
installPreloadErrorReload();

// Left default, the router wraps navigation in startTransition: React keeps the old page on
// screen and a click looks ignored until the route's chunk lands.
createRoot(document.getElementById('root')!).render(
  <BrowserRouter useTransitions={false}>
    <StrictMode>
      <Provider store={store}>
        <ThemedApp />
      </Provider>
    </StrictMode>
  </BrowserRouter>
);
